import React, { Component } from 'react';

import { EventDateInfo } from '../../../mvcapi/models/common';
import { map, chunk } from 'lodash';
import { EventDateInfoRow } from './';

export type EventDateInfoListProps = {
    items: EventDateInfo[],
    selectedItemIDs: number[],
    hidePackageEventDetailLink: boolean,
    overview: boolean,
    homeUrl: string,
    isFixedPackage: boolean,
    isMandatory?: boolean,
    onEventDateClick: (eventDateID: number, isSelected: boolean, isMandatory: boolean) => void
};

export type EventDateInfoListState = { };

export class EventDateInfoList extends Component<EventDateInfoListProps, EventDateInfoListState> {
    static readonly defaultProps = {
        selectedItemIDs: [],
        overview: false
    };

    constructor(props) {
        super(props);

    }

    render() {

        let rowKey = 0;
        const iteminfos = map(chunk(this.props.items, 2), function(items) {
            rowKey++;
            return <EventDateInfoRow
                        key={rowKey}
                        items={items}
                        isFixedPackage={this.props.isFixedPackage}
                        isMandatory={this.props.isMandatory}
                        hidePackageEventDetailLink={this.props.hidePackageEventDetailLink}
                        selectedItemIDs={this.props.selectedItemIDs}
                        overview={this.props.overview}
                        homeUrl={this.props.homeUrl}
                        onEventDateClick={this.props.onEventDateClick}
            />;

        }.bind(this));

        let content = null;
        if(iteminfos.length > 0) {
            content = (
                <div>
                    {iteminfos}
                </div>
            );
        }

        return content;
    }
}

